import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d78267d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "url-dialog-content" }
const _hoisted_2 = { class: "url-dialog-label" }
const _hoisted_3 = {
  key: 0,
  class: "url-dialog-name"
}
const _hoisted_4 = { class: "url-dialog-url-section" }
const _hoisted_5 = { class: "url-dialog-url-box" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "url-dialog-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_button = _resolveComponent("k-button")!
  const _component_dialog_actions_bar = _resolveComponent("dialog-actions-bar")!
  const _component_app_dialog = _resolveComponent("app-dialog")!

  return (_openBlock(), _createBlock(_component_app_dialog, {
    title: _ctx.localize('LinkForOrderProposal'),
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.orderProposalNoFormatted), 1),
        (_ctx.name)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.name), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("input", {
              type: "text",
              class: "url-dialog-url-input",
              value: _ctx.cartUrl,
              readonly: "",
              ref: "urlInput"
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_k_button, {
              class: "button-ghost",
              icon: 'copy',
              onClick: _ctx.copyToClipboard
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.localize('CopyToClipboard')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_k_button, {
              class: "button-ghost",
              icon: 'hyperlink-open',
              onClick: _ctx.openInNewTab
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.localize('OpenInNewTab')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _createVNode(_component_dialog_actions_bar, null, {
        default: _withCtx(() => [
          _createVNode(_component_k_button, {
            class: "button-cancel",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.localize('Close')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}